import { FilledInput, FilledInputProps, FormControl, FormControlProps, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FieldAttributes, useField } from 'formik';
import { FunctionComponent } from 'react';


const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    error: {
        color: theme.palette.error.main,
        wordBreak: "break-word", // breaks long string on mobile
        whiteSpace: "normal", // To allow in wraping 
    }
}));

type AppInputProps = {
    label: string
} & FilledInputProps & FormControlProps & FieldAttributes<{}>

export const AppInput: FunctionComponent<AppInputProps> = ({ label, ...props }) => {
    const classes = useStyles();
    const [field, meta,] = useField<{}>(props);
    const errorText = meta.error && meta.touched ? meta.error : "";

    return (
        <>
            <FormControl {...props} variant="filled">
                <InputLabel htmlFor="input">{label}</InputLabel>
                <FilledInput
                    id="input"
                    error={!!errorText}
                    {...props}
                    {...field}
                />
                <pre className={classes.error}>{errorText}</pre>
            </FormControl>
        </>
    )
}